import { FormEvent, ChangeEvent, KeyboardEvent, RefObject } from 'react';
import cn from 'classnames';
import { rm } from 'utils';
import { Button } from 'components/Button';
import { IconSearch, IconPlus } from 'components/Shared/Icon';
import styles from './searchForm.scss';

interface Props {
  onSubmit: (e: FormEvent) => void;
  isOpen: boolean;
  hasResults: boolean;
  searchPhrase: string;
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSearchKeyDown: (e: KeyboardEvent) => void;
  open: () => void;
  inputRef: RefObject<HTMLInputElement>;
  reset: () => void;
}

export const SearchForm = ({
  onSubmit,
  isOpen,
  searchPhrase,
  onSearchChange,
  onSearchKeyDown,
  open,
  inputRef,
  reset
}: Props) => (
  <form
    onSubmit={onSubmit}
    className={cn(styles.searchForm, {
      [styles.open]: isOpen
    })}
  >
    <Button type="submit" className={styles.searchButton}>
      <IconSearch className={styles.icon} />
    </Button>
    <input
      type="search"
      placeholder={rm('header_search_placeholder')}
      className={cn(styles.searchInput, { [styles.open]: isOpen })}
      value={searchPhrase}
      onChange={onSearchChange}
      onKeyDown={onSearchKeyDown}
      onFocus={open}
      ref={inputRef}
      id="search"
      autoComplete="off"
      enterKeyHint={'search'}
    />
    {isOpen && (
      <Button className={styles.closeResultView} onClick={reset}>
        <IconPlus className={styles.closeIcon} />
      </Button>
    )}
  </form>
);
